import { MapID } from "config/enums/mapIDs";
import { Overlay } from "config/enums/overlays";

// Kept separate from TangramTileLayer so the UI can use the layer metadata
// without pulling the Tangram library into the main bundle

export type TangramSceneMeta = {
  id: TangramMapID;
  name: string;
  label: string;
  isAnimated: boolean;
  hasLabels: boolean;
  colors?: { text: string; name: string }[];
  extraSupportedOverlays?: Overlay[];
};

export type TangramMapID =
  | MapID.basic
  | MapID.bubbleWrap
  | MapID.cinnabar
  | MapID.refill
  | MapID.street
  | MapID.topo
  | MapID.tron
  | MapID.walkabout
  | MapID.outdoors;

export const TANGRAM_LAYERS_META: TangramSceneMeta[] = [
  {
    id: MapID.basic,
    name: "basic",
    label: "Basic",
    isAnimated: false,
    hasLabels: false,
  },
  {
    id: MapID.bubbleWrap,
    name: "bubble-wrap",
    label: "Bubble Wrap",
    isAnimated: false,
    hasLabels: true,
  },
  {
    id: MapID.cinnabar,
    name: "cinnabar",
    label: "Cinnabar",
    isAnimated: false,
    hasLabels: true,
  },
  {
    id: MapID.outdoors,
    name: "outdoors",
    label: "Outdoors",
    isAnimated: false,
    hasLabels: false,
  },
  {
    id: MapID.refill,
    name: "refill",
    label: "Refill",
    isAnimated: false,
    hasLabels: true,
    colors: [
      { text: "Black", name: "black" },
      { text: "Blue", name: "blue" },
      { text: "Blue-gray", name: "blue-gray" },
      { text: "Brown-orange", name: "brown-orange" },
      { text: "High contrast", name: "high-contrast" },
      { text: "Gray", name: "gray" },
      { text: "Gray-gold", name: "gray-gold" },
      { text: "Inverted", name: "inverted" },
      { text: "Inverted-dark", name: "inverted-dark" },
      { text: "Pink", name: "pink" },
      { text: "Pink-yellow", name: "pink-yellow" },
      { text: "Purple-green", name: "purple-green" },
      { text: "Sepia", name: "sepia" },
      { text: "Zinc", name: "zinc" },
    ],
  },
  {
    id: MapID.street,
    name: "street",
    label: "Street",
    isAnimated: false,
    hasLabels: false,
  },
  {
    id: MapID.topo,
    name: "topo",
    label: "Topo",
    isAnimated: false,
    hasLabels: false,
  },
  {
    id: MapID.tron,
    name: "tron",
    label: "Tron",
    isAnimated: true,
    hasLabels: true,
  },
  {
    id: MapID.walkabout,
    name: "walkabout",
    label: "Walkabout",
    isAnimated: false,
    hasLabels: true,
    extraSupportedOverlays: [Overlay.bikePaths, Overlay.walkPaths],
  },
];

export const TANGRAM_LAYERS_LABELS = TANGRAM_LAYERS_META.map((layer) => ({
  label: layer.label,
  value: layer.id,
}));

export const isTangramLayer = (id: MapID) =>
  TANGRAM_LAYERS_META.some((layer) => layer.id === id);

export const getTangramLayerMeta = (id: MapID) =>
  TANGRAM_LAYERS_META.find((layer) => layer.id === id);
